'use strict';

angular.module('shiftTraderApp')
  .factory('TradeRecommendations', function (ServerUrls, Session, $http, WorkPeriods, $q) {
    var theTz = Session.getTimezone();

    //Notification model constructor
    var TradeRecommendation = function(wpId, wps) {
      var A = {};
      var temp;
      A.workPeriods = _.map(wps, function(wp) {
        temp = WorkPeriods.initWithData(wp);
        if (temp._receiverWorkPeriodOverlaps.length > 0) {
          temp._receiverWorkPeriodOverlaps = _.map(temp._receiverWorkPeriodOverlaps, function (x) {
            x.workPeriod = WorkPeriods.initWithData(x.workPeriod);
            return x;
          });

        }
        if (temp._initiatorWorkPeriodOverlaps.length > 0) {
          temp._initiatorWorkPeriodOverlaps = _.map(temp._initiatorWorkPeriodOverlaps, function(x) {
            x.workPeriod = WorkPeriods.initWithData(x.workPeriod);
            return x;
          });
        }

        if (temp._initiatorAvailabilityResults.data.length > 0) {
          _.forEach(temp._initiatorAvailabilityResults.data, function(iar) {
            if (_.has(iar.data, 'start')) {
              iar.data = (moment.utc(iar.data.start).tz(theTz)).twix(moment.utc(iar.data.end).tz(theTz));
            }
          });
        }

        if (temp._receiverAvailabilityResults.data.length > 0) {
          _.forEach(temp._receiverAvailabilityResults.data, function(iar) {
            if (_.has(iar.data, 'start')) {
              iar.data = (moment.utc(iar.data.start).tz(theTz)).twix(moment.utc(iar.data.end).tz(theTz));
            }
          });
        }
        return temp;
      });
      A.wpId = wpId;
      return A;
    };

    var TradeRecommendations = {};

    TradeRecommendations.getTradeRecForWpId = function(wpId) {
      var url = ServerUrls.current.nodeApi;
      return $http.get(url + 'trade_recommendation/' + wpId)
        .then(function(response) {
          return new TradeRecommendation(wpId, response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    TradeRecommendations.initWithData = function(data) {
      return new TradeRecommendation(data);
    };

    return TradeRecommendations;
  });
